import { render, staticRenderFns } from "./instantPayment.vue?vue&type=template&id=12d2eede&scoped=true"
import script from "./instantPayment.vue?vue&type=script&lang=js"
export * from "./instantPayment.vue?vue&type=script&lang=js"
import style0 from "./instantPayment.vue?vue&type=style&index=0&id=12d2eede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2eede",
  null
  
)

export default component.exports